import React from "react";
import EstimationFraisNotaire from "../components/EstimationFraisNotaire";
import { useSEO } from "../hooks/useSEO";

export default function EstimationFraisNotairePage() {
  useSEO({
    title: "Calculateur Frais de Notaire Gratuit 2024",
    description: "Calculez gratuitement vos frais de notaire pour un achat immobilier. Estimation précise pour l'ancien et le neuf avec détail des droits de mutation."
  });

  return <EstimationFraisNotaire />;
}
